import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { adminReflections } from "@/lib/api";

export default function AdminReflections() {
  const [items, setItems] = useState([]);
  useEffect(() => { adminReflections().then(setItems).catch(() => {}); }, []);
  return (
    <AdminLayout>
      <h1 className="rbl-h1" style={{ fontSize: 34 }}>Reflections</h1>
      <p className="rbl-intro">All participant journal entries (read-only).</p>
      <div style={{ marginTop: 18 }} data-testid="reflections-list">
        {items.length === 0 && <p style={{ color: "var(--muted)" }}>No reflections yet.</p>}
        {items.map((r) => (
          <div key={r.id} className="rbl-list-item" style={{ display: "block" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <strong>{r.participant_name}</strong>
              <span style={{ color: "var(--muted)", fontSize: 12 }}>{r.created_at ? new Date(r.created_at).toLocaleString() : ""}</span>
            </div>
            {r.prompt_text && <div style={{ color: "var(--navy)", fontWeight: 700, fontSize: 13, marginTop: 4 }}>{r.prompt_text}</div>}
            <div style={{ whiteSpace: "pre-wrap", marginTop: 4 }}>{r.text}</div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
